import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { ordersPageTabAtom } from '../../atoms/mobile'

import { OrdersList } from './orders-list'
import { OrdersPageHeader } from './orders-page-header'

type Props = {}

export const OrdersPage: React.FC<Props> = () => {
  const [tab] = useAtom(ordersPageTabAtom)

  const renderContent = () => {
    return match(tab)
      .with('orders', () => <OrdersList />)
      .with('tokens', () => <div />)
      .exhaustive()
  }

  return (
    <Root>
      <OrdersPageHeader />
      {renderContent()}
    </Root>
  )
}

const Root = styled.div`
  background: var(--background-1);
  padding-block: 14px 100px;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
